import { format } from "date-fns"

export const getDurationLabel = (startDate, endDate) => {
  let label = "";

  const isSameYear = startDate?.getFullYear() === endDate?.getFullYear();

  let dateFormat = isSameYear ? "dd LLL" : "dd LLL yy";

  let startDateString = format(startDate, dateFormat);

  if(!isSameYear) {
    startDateString = startDateString.slice(0, startDateString.length - 2) + "'" + startDateString.slice(startDateString.length-2);
  }

  if(endDate) {
    let endDateString = format(endDate, dateFormat);
    if(!isSameYear) {
      endDateString = endDateString.slice(0, endDateString.length - 2) + "'" + endDateString.slice(endDateString.length - 2);
    }

    label = `${startDateString} to ${endDateString}`;
  } else {
    label = `from ${startDateString}`;
  }

  return label;
}

export function toHoursAndMinutes(totalMinutes) {
  if (totalMinutes <= 60) {
    return `${totalMinutes}min`;
  }
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h${minutes > 0 ? ` ${minutes}min` : ""}`;
}
